import React from 'react'
import { GoalDetailPage } from './GoalDetailPage.jsx'

export function GoalPage({ goalId, me, ownerUserId = null, onBack, onGoalChanged }) {
  return (
    <GoalDetailPage
      goalId={goalId}
      me={me}
      ownerUserId={ownerUserId}
      onBack={onBack}
      onGoalChanged={onGoalChanged}
    />
  )
}
